import { Component, OnInit, Input } from '@angular/core';

// classes 
import { Event } from '../../../classes/classes';

@Component({
  selector: 'events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.sass']
})
export class EventsComponent implements OnInit {

  @Input() events_pool: Event[];
  anyEvents = true;
  constructor() { }

  ngOnInit() {
    if (this.events_pool === undefined || this.events_pool.length === 0) {
      this.anyEvents = false;
    }
  }

}
